import React, { memo, useCallback } from 'react';
import { useTrackEvent } from '@olxeu-a2b/delivery-utils/src/tracking/useNinja';
import DetailsCard from './DetailsCard';
import useI18n from '../../../../i18n/hooks/useI18n';

import S from './style/SupportCard';
import trackingKeys from '../../../../commons/constants/trackingKeys';
import {
  type Tab,
  TAB_TYPE_BUYING,
  TAB_TYPE_CLAIMS_AND_RETURNS,
  TAB_TYPE_SELLING,
} from '../../constants';

interface SupportCardProps {
  createTicketUrl?: string;
  isSeller?: boolean;
  trackingExtras?: {
    seller_type: 'seller' | 'buyer';
    ad_id: number;
    seller_id: string;
  };
  tab: Tab;
}

export const SupportCardContent: React.FC<SupportCardProps> = ({
  createTicketUrl,
  isSeller,
  tab,
  trackingExtras,
}) => {
  const i18n = useI18n();
  const trackEvent = useTrackEvent();
  const i18nKey = useCallback((key, ...rest) => i18n(`dlv_orders_details_${key}`, ...rest), []);

  let userType: string = null;
  let tpp: string = null;

  if (tab === TAB_TYPE_SELLING) {
    userType = trackingKeys.events.deliveryHelpSeller;
    tpp = trackingKeys.touchPointPage.deliverySales;
  } else if (tab === TAB_TYPE_BUYING) {
    userType = trackingKeys.events.deliveryHelpBuyer;
    tpp = trackingKeys.touchPointPage.deliveryPurchases;
  } else if (tab === TAB_TYPE_CLAIMS_AND_RETURNS && isSeller) {
    userType = trackingKeys.events.deliveryHelpSeller;
    tpp = trackingKeys.touchPointPage.returns.returnDetails;
  } else {
    userType = trackingKeys.events.deliveryHelpBuyer;
    tpp = trackingKeys.touchPointPage.returns.returnDetails;
  }

  const trackClick = () => {
    trackEvent(userType, null, null, { ...trackingExtras, touch_point_page: tpp });
  };

  return (
    <S.Wrapper>
      <S.SupportIcon />
      <S.InfoBlock>
        <S.Info>{i18nKey`support_message`}</S.Info>
        <S.EmailTo href={createTicketUrl} target="__blank" onClick={trackClick}>
          {i18nKey`support_help_center`}
        </S.EmailTo>
      </S.InfoBlock>
    </S.Wrapper>
  );
};

const SupportCard: React.FC<SupportCardProps> = function SupportCard({
  createTicketUrl = '',
  tab,
}) {
  const i18n = useI18n();
  const i18nKey = useCallback((key, ...rest) => i18n(`dlv_orders_details_${key}`, ...rest), []);

  return (
    <DetailsCard data-cy="support-info" title={i18nKey`support_title`}>
      <S.Container>
        <SupportCardContent createTicketUrl={createTicketUrl} tab={tab} />
      </S.Container>
    </DetailsCard>
  );
};

export default memo(SupportCard);
